// 페이지 내부 스크롤에 대한 이벤트 리스너 추가
function scrollStatus() {
    // scrollTop 값이 200보다 큰지 확인
    let scrollEl = document.querySelector(".page_inner");
    // // console.log("###", scrollEl.scrollTop) 
    if (scrollEl.scrollTop > 200) {
      document.querySelector(".scroll-to-top").style.display = "block"; // fadeIn 효과 대신 display 속성으로 제어
      // // console.log(1, document.querySelector(".scroll-to-top").style.display);
    } else {
      document.querySelector(".scroll-to-top").style.display = "none"; // fadeOut 효과 대신 display 속성으로 제어
      // // console.log(2, document.querySelector(".scroll-to-top").style.display);
    }
  }
  
  function clickScroll() {
    let scrollEl = document.querySelector(".page_inner");
    // // console.log('scroll');
    scrollEl.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
  
  export function addScrollHandler() {
    let scrollEl = document.querySelector(".page_inner");
    let scrollTopBtn = document.querySelector(".scroll-to-top");
    if (scrollEl && scrollTopBtn) {
      // // console.log('Adding event listeners');
      scrollEl.addEventListener("scroll", scrollStatus());
      scrollTopBtn.addEventListener("click", clickScroll);
    } else {
      // // console.log('Element not found:', scrollEl, scrollTopBtn);
    }
  }
  
  export function removeScrollHandler() {
    let scrollEl = document.querySelector(".page_inner");
    let scrollTopBtn = document.querySelector(".scroll-to-top");
    // window.scrollTop = 0; // 초기화
    // body.scrollTo(0,0);
    if (scrollEl && scrollTopBtn) {
      scrollEl.removeEventListener("scroll", scrollStatus);
      scrollTopBtn.removeEventListener("click", clickScroll);
    }
  }
  